import { createSlice } from "@reduxjs/toolkit";

import { PatientsState } from "@/store/types";

import { ServerError } from "@/lib/types";
import {
  getPatient,
  getPatients,
  getPatientProgram,
  updatePatientDayProgram,
  getPatientsTodo,
  getPatientHealthReport,
  getPatientFeedbacks,
} from '@/store/actions/patients-actions';

const initialState: PatientsState = {
  error: "",
  users: null,
  selected: null,
  calendar: [],
  program: null,
  healthReport: [],
  feedbacks: [],
  todo: [],
  loader: {
    users: false,
    selected: false,
    calendar: false,
    program: false,
    todo: false,
    healthReport: false,
    feedbacks: false,
  }
};

const specialistsSlice = createSlice({
  name: "specialists",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // ============= get patients =============
      .addCase(getPatients.pending, (state) => {
        state.loader.users = true;
        state.users = null;
        state.error = "";
      })
      .addCase(getPatients.fulfilled, (state, { payload }) => {
        state.loader.users = false;
        state.users = payload;
      })
      .addCase(getPatients.rejected, (state, action: any & { payload: ServerError }) => {
        state.loader.users = false;
        state.error = action.payload.message;
      })
      // ============= get patients =============
      .addCase(getPatientsTodo.pending, (state) => {
        state.loader.todo = true;
        state.todo = [];
        state.error = "";
      })
      .addCase(getPatientsTodo.fulfilled, (state, { payload }) => {
        state.loader.todo = false;
        state.todo = payload;
      })
      .addCase(getPatientsTodo.rejected, (state, action: any & { payload: ServerError }) => {
        state.loader.todo = false;
        state.error = action.payload.message;
      })
      // ============= get patient =============
      .addCase(getPatient.pending, (state) => {
        state.loader.selected = true;
        state.selected = null;
        state.error = "";
      })
      .addCase(getPatient.fulfilled, (state, { payload }) => {
        state.loader.selected = false;
        state.selected = payload;
      })
      .addCase(getPatient.rejected, (state, action: any & { payload: ServerError }) => {
        state.loader.selected = false;
        state.error = action.payload.message;
      })
      // ============= get patient program =============
      .addCase(getPatientProgram.pending, (state) => {
        state.loader.program = true;
        state.program = null;
        state.error = "";
      })
      .addCase(getPatientProgram.fulfilled, (state, { payload }) => {
        state.loader.calendar = false;
        state.program = payload;
      })
      .addCase(getPatientProgram.rejected, (state, action: any & { payload: ServerError }) => {
        state.loader.program = false;
        state.error = action.payload.message;
      })
      // ============= update patient day program =============
      .addCase(updatePatientDayProgram.pending, (state) => {
        state.loader.calendar = true;
        state.calendar = [];
        state.error = "";
      })
      .addCase(updatePatientDayProgram.fulfilled, (state, { payload }) => {
        state.loader.calendar = false;
        state.calendar = payload;
      })
      .addCase(updatePatientDayProgram.rejected, (state, action: any & { payload: ServerError }) => {
        state.loader.calendar = false;
        state.error = action.payload.message;
      })
      // ============= get patient health report =============
      .addCase(getPatientHealthReport.pending, (state) => {
        state.loader.healthReport = true;
        state.healthReport = [];
        state.error = "";
      })
      .addCase(getPatientHealthReport.fulfilled, (state, { payload }) => {
        state.loader.healthReport = false;
        state.healthReport = payload;
      })
      .addCase(getPatientHealthReport.rejected, (state, action: any & { payload: ServerError }) => {
        state.loader.healthReport = false;
        state.error = action.payload.message;
      })
      // ============= get patient feedbacks =============
      .addCase(getPatientFeedbacks.pending, (state) => {
        state.loader.feedbacks = true;
        state.feedbacks = [];
        state.error = "";
      })
      .addCase(getPatientFeedbacks.fulfilled, (state, { payload }) => {
        state.loader.feedbacks = false;
        state.feedbacks = payload;
      })
      .addCase(getPatientFeedbacks.rejected, (state, action: any & { payload: ServerError }) => {
        state.loader.feedbacks = false;
        state.error = action.payload.message;
      })
  }
});

export default specialistsSlice.reducer;
